
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_t74ok_99",
  "marker--line": "awsui_marker--line_1isd1_t74ok_142",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_t74ok_146",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_t74ok_153",
  "marker--dashed": "awsui_marker--dashed_1isd1_t74ok_169"
};
  